<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group class="float-right">
        <router-link to="/iptal/makbuz" tag="button" class="el-button YeniBtn el-button--primary el-button--small">
          Makbuz İptal
        </router-link>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="19">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            ref="multipleTable"
            class="table-xs"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="Tarih"
              prop="Tarih"
              width="150">
            </el-table-column>
            <el-table-column
              label="Makbuz No"
              width="120">
              <template slot-scope="scope">
                <a @click="Islem(scope.row)">
                  <span>{{ scope.row.mNo }}</span>
                </a>
              </template>
            </el-table-column>
            <el-table-column
              label="Kullanıcı"
              prop="Kullanici">
            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="5">
          <div class="raporbloksabitle">
            <el-collapse class="Filtre" v-model="FiltreCollapse">
              <el-collapse-item :title="Sayfa.FiltreAdi" name="1">

                <el-form :rules="FormHata" :model="Form"
                         @submit.prevent.native="Getir"
                         ref="FiltreForm">
                  <el-form-item label="Makbuz No" prop="Makbuz No">
                    <el-input v-model="Form.mNo"></el-input>
                  </el-form-item>
                  <div v-if="!Form.mNo">

                    <el-form-item label="İşlem Tarih Aralığı" prop="Tarih">
                      <el-date-picker
                        v-model="Form.Tarih"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Başlangıç Tarihi"
                        end-placeholder="Bitiş Tarihi"
                        format="dd.MM.yyyy"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                  <el-button type="primary" class="btn-block" size="medium" @click="Getir()"
                             icon="el-icon-check"><span v-if="Form.mNo">İptal Makbuz Görüntüle</span> <span
                    v-if="!Form.mNo">İptal Makbuzları Getir</span>
                  </el-button>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
    </div>
    <MakbuzDetay v-if="MakbuzDetayModal" :IptalDetay="IptalDetay" :mNo="mNo" :Iptal="Detay"
                 @MakbuzDetayModal="ModalKapat"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>

import MakbuzDetay from "../../components/Pack/Vezne/MakbuzDetay";
import Yukleniyor from "../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, MakbuzDetay},
  data() {
    return {
      FiltreCollapse: '1',
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Makbuz İptal Log',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Tarih: [],
        mNo: null,
      },
      FormHata: {
        Tur: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        mNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      MakbuzDetayModal: false,
      mNo: null,
      Detay: null,
      IptalDetay: null,
      tableData: [],
      tableDisplay: false,

    }
  },
  methods: {

    Islem(Detay) {
      this.Detay = Detay.Json;
      this.mNo = Detay.mNo;
      this.MakbuzDetayModal = true;
      this.IptalDetay = "BU MAKBUZ " + Detay.Tarih + " TARİHİNDE " + Detay.Kullanici + " KULLANICISI TARAFINDAN İPTAL EDİLMİŞTİR.";
    },
    ModalKapat() {
      this.mNo = null;
      this.Form.mNo = null;
      this.MakbuzDetayModal = false;
      this.Getir();

    },
    MakbuzGetir(mNo) {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'iptal/makbuzlog/' + mNo})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.Islem(response.Detay);
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    Getir() {
      if (!this.Form.mNo) {
        this.FormHata = {
          Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }
      }
      if (this.Form.mNo) {
        this.MakbuzGetir(this.Form.mNo);
      } else {
        this.$refs['FiltreForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'iptal/makbuzlog/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.Data;
                  this.tableDisplay = true;
                } else {
                  this.$message.error(response.Mesaj);
                  this.tableDisplay = false;
                }
              })
          }
        })
      }
    },
  },
  created() {
    this.Yetki = this.$store.getters.Yetki.iptal == 2 ? true : false;
    var Gun = new Date();
    var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Form.Tarih[0] = Gun;
    this.Form.Tarih[1] = AySonu;
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/Iptal/makbuzlog.vue